import './assets/reset.css'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

import Axios from 'axios'
import VueAxios from 'vue-axios'
import VueXgplayer from 'vue-xgplayer'
import { VueHammer } from 'vue2-hammer'

Vue.use(VueAxios, Axios)
Vue.use(VueHammer)
Vue.use(VueXgplayer, {
  // globalOptions
  enterLogo: {
    url: '',
    width: 0,
    height: 0
  },
  playsinline: true
})
Vue.config.productionTip = false

Axios.defaults.baseURL = store.state.baseUrl;
Axios.defaults.headers.post['Content-Type'] = 'text/json';
Axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

new Vue({
  el: '#PSP',
  router,
  store,
  components: { App },
  template: '<App/>'
});

if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  navigator.serviceWorker
    .register('/static/sw.js')
    .then(function() { console.log('PSP Service Worker v1.10 Registered'); });
}

console.log('%c| 🖍 Design by Duall. 🔧 Development by 8 interactive |', 'background: #111; color: #eee; border-radius:2px;')



// WEBPACK FOOTER //
// ./src/main.js